export default __webpack_public_path__ + "static/media/veeyashu.ce9755f9.png";